const invoicesNL = {
    "view": {
        "table": {
            "title": "Uw facturenlijst",
            "column": {
                "issueDate": "Uitgiftedatum",
                "invoiceNumber": "Factuurnummer",
                "status": "Status",
                "totalAmount": "Totaalbedrag",
                "downloadPDF": "Download PDF",
                "whtStatement": "WHT-verklaring"
            },
            "label": {
                "notApplicable": "Niet van toepassing"
            },
            "placeholder": {
                "search": "Zoeken..."
            },
            "button": {
                "download": "Downloaden",
                "exportCSV": "Exporteer CSV"
            }
        },
        "message": {
            "cantAddInvoices": "Helaas kunt u momenteel geen facturen toevoegen. Ofwel uw belasting- of betalingsaccountgegevens zijn niet volledig ingevuld. Neem contact op met ons ondersteuningsteam om deze functie te ontgrendelen.",
            "invoicingNotAvailable": "Genereer facturen van de 3e tot de 22e van elke maand. Merk op dat factuurgeneratie niet mogelijk is van de 23e tot de 2e van de volgende maand, omdat tijdens deze periode automatische betalingen worden verwerkt. Bedankt voor uw begrip.",
            "generatingInvoices": "U kunt op dit moment geen facturen toevoegen omdat u facturen heeft die momenteel worden gegenereerd. Kom later terug.",
            "noAccess": "U heeft geen toegang tot deze module, neem contact op met het ondersteuningsteam voor meer informatie.",
            "subscriptionExpired": "Uw abonnement is verlopen. <1>Hervat</1> uw abonnement om gebruik te maken van deze functie.",
            "subscriptionUpgrade": "Uw huidige abonnementsplan ondersteunt deze functie niet. <1>Upgrade</1> uw abonnementsplan om gebruik te maken van deze functie."
        }
    },
    "add": {
        "title": "Factuur toevoegen",
        "form": {
            "table": {
                "statements": {
                    "title": "Verklaringen beschikbaar voor facturering"
                }
            },
            "button": {
                "generateInvoice": "Factuur genereren"
            }
        },
        "message": {
            "success": "Factuur is toegevoegd!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!",
            "noStatementAvailable": "Geen verklaring beschikbaar voor facturering.",
            "invoicingLimitNotReached": "U kunt momenteel geen facturen toevoegen omdat de totale te betalen som kleiner of gelijk is aan <strong>0€</strong>."
        },
        "modal": {
            "header": "Factuur toevoegen",
            "body": "Weet u zeker dat u een factuur wilt maken voor momenteel OPEN verklaringen?"
        }
    }
};

export default invoicesNL;